import styled, { css } from 'styled-components'
import {
  calculateResponsiveSize,
  mediaMax
} from '@dboxdev/ui-components'
import { palette } from 'styles/global-styles'
import {
  CHROME_IN_DELAY,
  CHROME_IN_FADE,
  CHROME_IN_SHIFT,
  SPLASH_EASE_OUT
} from 'styles/splash-timing'

const away = css`
  transform: translateY(${calculateResponsiveSize(-CHROME_IN_SHIFT)});
  opacity: 0;
  pointer-events: none;
  transition:
    transform ${CHROME_IN_FADE}s ${SPLASH_EASE_OUT},
    opacity ${CHROME_IN_FADE}s ${SPLASH_EASE_OUT};
`

const settled = css`
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
  transition:
    transform ${CHROME_IN_FADE}s ${SPLASH_EASE_OUT} ${CHROME_IN_DELAY}s,
    opacity ${CHROME_IN_FADE}s ${SPLASH_EASE_OUT} ${CHROME_IN_DELAY}s;
`

export const Wrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  color: var(--chrome-color);
  --button-color: var(--chrome-color);
  --button-contrast: var(--chrome-contrast);
  ${({ $hidden }) => ($hidden ? away : settled)};
  z-index: 10;
  & > button {
    position: absolute;
    top: ${calculateResponsiveSize(25)};
    right: ${calculateResponsiveSize(40)};
    z-index: 2;
  }
  ${mediaMax('mobile')} {
    height: ${calculateResponsiveSize(51)};
    --chrome-color: ${palette.umber};
    --chrome-contrast: ${palette.creamLight};
    & > button {
      top: ${calculateResponsiveSize(15)};
      right: ${calculateResponsiveSize(20)};
    }
    :root[data-panel='last'] && {
      transform: translateY(-100%);
      opacity: 0;
      pointer-events: none;
      transition-delay: 0s;
    }
  }
`

export const LogoLink = styled.a`
  position: absolute;
  top: ${calculateResponsiveSize(20)};
  left: ${calculateResponsiveSize(40)};
  z-index: 2;
  ${mediaMax('mobile')} {
    top: ${calculateResponsiveSize(14)};
    left: ${calculateResponsiveSize(20)};
  }
`

export const Shadow = styled.div`
  position: absolute;
  inset: 0;
  height: ${calculateResponsiveSize(90)};
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.32) 0%, rgba(0, 0, 0, 0) 70%);
  background-blend-mode: multiply;
  opacity: var(--chrome-dark, 0);
  pointer-events: none;
  z-index: 1;
  ${mediaMax('mobile')} {
    display: none;
    :root:not([data-deck]) && {
      display: block;
      opacity: 1;
      background: linear-gradient(180deg, ${palette.warmWhite} 0%, rgba(255, 253, 247, 0) 100%);
    }
  }
`
